import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const DEFAULT_NO_VALUE = '-'

const authorProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'author',
  title: i18n.t('documents.employee.list.uploaded_by'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ author }) => {
    const access = users.get(author?.id)
    if (!access) return <Text.Normal overflowWrap>{DEFAULT_NO_VALUE}</Text.Normal>

    const fullName = author?.fullName
    const { avatar } = access

    return (
      <Box gap="s8" flexDirection="row" alignItems="center">
        {avatar && fullName && <Avatar label={fullName} url={buildUrl(avatar)} size="s32" />}
        <Text.Normal>{fullName}</Text.Normal>
      </Box>
    )
  },
  colSpan: 2,
})

export default authorProjection
